@use '@lib/assets/styles/main.scss' as *;

.uppyRoot {
  height: 100%;
  display: grid;
  &:not(.uppyRootWithMessage) {
  }
  &.uppyRootWithMessage {
    grid-template-rows: minmax(0, auto) min-content;
  }
  & *:not([class*="material-icons"]) {
    font-family: 'Inter', sans-serif;
  }
}
